/**
 * Виджет AI-консультанта (чат «Антоша»).
 * - REACT_APP_ENABLE_AI_CHAT=true — показать (локальная разработка / отдельный билд).
 * - REACT_APP_ENABLE_AI_CHAT=false — скрыть.
 * - Иначе: скрыт (в т.ч. тест и прод по умолчанию).
 * Локально включить: в frontend/.env.local добавить REACT_APP_ENABLE_AI_CHAT=true
 */
export function isAIConsultantChatEnabled() {
  const v = process.env.REACT_APP_ENABLE_AI_CHAT;
  if (v === 'true') return true;
  if (v === 'false') return false;
  return false;
}
